import { motion } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";

export const Next = ({ name, link }) => {
    const navigate = useNavigate();

    return (
        <div
            onClick={() => navigate(link)}
            to={link}
            className="next"
        >
            <span className="text">
                {name}
            </span>
            <span>
                <motion.i className="bi bi-chevron-compact-right"></motion.i>
            </span>
        </div>
    )
}

export const Before = ({ name, link }) => {
    const navigate = useNavigate();

    return (
        <div
            onClick={() => navigate(link)}
            to={link}
            className="before"
        >
            <span>
                <motion.i className="bi bi-chevron-compact-left"></motion.i>
            </span>
            <span className="text">
                {name}
            </span>
        </div>
    )
}


export const BtnPrev = ({to}) => {
    const navigate = useNavigate();
    return (
        <div
            onClick={() => navigate(to)} 
            className="btn-prev"
        >
            <span>
                <motion.i className="bi bi-grid-1x2-fill"></motion.i>
            </span>
        </div>
    )
}
